import React from "react";
import { Sun, Snowflake, Flower2, Leaf, CalendarRange, Home, Trees, ArrowLeftRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { SEASONS, ENVIRONMENTS, WEAR_TITLES } from "../lib/classifications";

const ICONS = {
  summer: Sun, winter: Snowflake, spring: Flower2, autumn: Leaf, all: CalendarRange,
  indoor: Home, outdoor: Trees, both: ArrowLeftRight,
};

const Chip = ({ item, lang, testId }) => {
  const Icon = ICONS[item.key];
  return (
    <span data-testid={testId} className="inline-flex items-center gap-2 border border-[#2A2824] bg-[#141311]/60 px-3 py-2 text-xs text-[#EAE3D8] tracking-wide">
      <Icon size={14} strokeWidth={1.3} className="text-[#C49A6C] shrink-0" />
      {item[lang]}
    </span>
  );
};

const Row = ({ title, items, lang, field }) => (
  <div data-testid={`wear-${field}`} className="py-5 border-t border-[#1E1C19]">
    <p className="text-[10px] uppercase tracking-[0.3em] text-[#8A857D] mb-3">{title}</p>
    <div className="flex flex-wrap gap-2">
      {items.map((it) => <Chip key={it.key} item={it} lang={lang} testId={`wear-${field}-${it.key}`} />)}
    </div>
  </div>
);

export const WearGuide = ({ product }) => {
  const { lang } = useLang();
  const seasons = SEASONS.filter((s) => (product.seasons || []).includes(s.key));
  const env = ENVIRONMENTS.filter((e) => e.key === product.environment);
  if (!seasons.length && !env.length) return null;
  return (
    <div className="mt-2" data-testid="wear-guide">
      {seasons.length > 0 && <Row title={WEAR_TITLES.seasons[lang]} items={seasons} lang={lang} field="seasons" />}
      {env.length > 0 && <Row title={WEAR_TITLES.environment[lang]} items={env} lang={lang} field="environment" />}
    </div>
  );
};
